import React from "react";
import { useNavigate } from "react-router";
import { Card, CardBody } from "reactstrap";
const DashboardCards = ({ element, toggleCreateDriverModal }) => {
  const navigate = useNavigate();
  const checkAdhoc = () => {
    if (element.title == "Adhoc") {
      toggleCreateDriverModal();
    } else if (element.key == "onLineDrivers") {
      navigate("/driver/cab/cab-listing", {
        state: {
          filterdata: [{
            key: "STATUS",
            column_name: "status",
            values: ["OnLine"],
          }]
        }
      })
    } else if (element.key == "zoneCaptureCount") {
      navigate("/driver/cab/zone-listing", {
        state: {
          filterdata: [{
            key: "STATUS",
            column_name: "current_car_status",
            values: ["OffLine"],
          }]
        }
      })
    } else if (element.key == "onTripCabs") {
      navigate("/driver/cab/cab-listing", {
        state: {
          filterdata: [{
            key: "STATUS",
            column_name: "status",
            values: ["OnTrip"],
          }]
        }
      })
    } else if (element.key == "executedTrips") {
      navigate("/trips/trip-history", {
        state: {
          filterdata: [{
            key: "STATUS",
            column_name: "current_trip_status_type",
            values: ["Complete"],
          }]
        }
      })
    } else if (element.key == "nonFullFilledTrips") {
      navigate("/trips/trip-history", {
        state: {
          filterdata: [{
            key: "STATUS",
            column_name: "current_trip_status_type",
            values: ["Cancelled"],
          }]
        }
      })
    } else if (element.key == "manualTrips") {
      navigate("/booking/booking-history", {
        state: {
          filterdata: [
            {
              key: "STATUS",
              column_name: "current_booking_status_type",
              values: ["ForManualAssignment"],
            }
          ]
        }
      })
    } else if (element.key == "airportToCity") {
      navigate("/booking/booking-history", {
        state: {
          filterdata: [
            // {
            //   key: "STATUS",
            //   column_name: "current_booking_status_type",
            //   values: ["InProgress"],
            // },
            {
              key: "PICKUP TYPE",
              column_name: "pickup_type",
              values: ["AirportToCity"],
            }
          ]
        }
      })
    }
  };
  return (
    <Card
      className="dispatch-dashboard-data-card"
      style={{ backgroundColor: element.backgroundColor, cursor: element.isCursorHovered ? "pointer" : "default" }}
      onClick={() => checkAdhoc()}
    >
      <CardBody>
        <div className="circle-image">
          <div className="circle-value">{element.value}</div>
          <img src={element.circleIcon} alt="Cicle SVG" />
        </div>
        <div className="dispatch-dashboard-data-content">
          <div style={{ fontSize: "18px" }}>{element.title}</div>
          <div>{element.subtitle}</div>
          <div className="car-icon">{element.icon}</div>
        </div>
      </CardBody>
    </Card>
  );
};

export default DashboardCards;
